import styled, { css } from "styled-components";
import { COLORS, DEVICE_TYPE, SIZE } from "constants/variables";
import { PageSection } from "./AboutPageModel";

export const AboutPageContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const ScrollWrapper = styled.div`
  grid-row: 1;              
  position: sticky;
  top: 80px;              
  z-index: 100;
  background-color: ${COLORS.Background};

`;

export const SectionsRow2 = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  grid-row: 2;
  background-color: ${COLORS.Background};
  // overflow-y: auto;
  height:100%;
   & > *:first-child {
    margin-top: 100px;
  }
`;

export const SectionContainer = styled.div<{ section: PageSection }>`
  ${({ section }) =>
    section === PageSection.ORGANIZE &&
    css`
    width: 100%;
      padding: ${SIZE.max60} ${SIZE.max80};
      @media (max-width: 768px) {
        padding-inline: ${SIZE.max24};
      }
    `}

  ${({ section }) =>
    (section === PageSection.ATTRIBUTIONS || section === PageSection.MISSION) &&
    css`
      padding: ${SIZE.max140} ${SIZE.max80};
    `}

  ${({ section }) =>
    section === PageSection.PERSONNEL &&
    css`
      padding-block: ${SIZE.fix120} 0;
    `}
  ${({ section }) =>
    section === PageSection.PROJECTS &&
    css`
      padding-block: ${SIZE.max260} 0;
    `}


  ${({ section }) =>
    section === PageSection.PARTNERS &&
    css`
      padding-inline: ${SIZE.max224};
      padding-block: ${SIZE.max80} 0;

      @media (max-width: 1120px) {
        padding-block: ${SIZE.max400} 0;
      }

      @media (max-width: 1025px) {
        padding-block: ${SIZE.max360} 0;
      }
      @media (max-width: 767px) {
        padding-inline: ${SIZE.max24};
        padding-block: ${SIZE.max550} 0;
      }
    `}

  ${({ section }) =>
    section === PageSection.REPORTS &&
    css`
      width: 100%;
      padding-block: ${SIZE.max140} 0;
      display: flex;
      justify-content: center;

      @media (max-width: 950px) {
        padding-inline: ${SIZE.max224};
      }

      @media (max-width: 768px) {
        padding-block: ${SIZE.max120} 0;
        padding-inline: ${SIZE.max24};
      }
    `}
`;
